import { PriceItemDto } from "api"
import { formatPrice } from "common/price"
import styled, { css } from "styled-components"
import NumericBadge from "./NumericBadge"

const StyledContainer = styled.div`
  margin: ${(p) => p.theme.spacing(1, 0)};
`
const StyledLabel = styled.span`
  font-size: 18px;
  font-weight: 300;
  line-height: 1.3;
  display: flex;
  align-items: center;
  gap: 9px;
`
const StyledPrice = styled.span<{ $original?: boolean }>`
  margin-right: 10px;
  letter-spacing: 0.64px;
  color: ${(p) => p.theme.palette.text.primary};
  font-size: 16px;
  direction: ltr;
  ${(p) =>
    p.$original &&
    css`
      font-size: 12px;
      margin-right: auto;
      text-decoration: line-through;
    `}
`
const StyledPrices = styled.span<{ $original?: boolean }>`
  margin-right: ${(p) => p.theme.spacing(1)}px;
  direction: ltr;
  display: flex;
  align-items: center;
  ${(p) =>
    p.$original &&
    css`
      font-size: 12px;
      margin-right: auto;
      text-decoration: line-through;
    `}
`
const StyledRow = styled.div<{ $final?: boolean; $finalDiscount?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;

  ${(p) =>
    p.$final &&
    css`
      ${StyledLabel} {
        font-weight: 600;
        letter-spacing: 0.72px;
      }

      ${StyledPrice} {
        font-weight: bold;
        letter-spacing: 0.8px;
      }
    `}

  ${(p) =>
    p.$finalDiscount &&
    css`
      ${StyledLabel} {
        font-weight: 400;
        color: black;
        font-size: 20px;
      }

      ${StyledPrice} {
        font-weight: 700;
        color: black;
        font-size: 24px;
      }
    `}
`

type PriceDetailProps = {
  label: string
  price: PriceItemDto | number
  final?: boolean
  finalDiscount?: boolean
  itemNumber?: number
}

const OnlinePrices = ({
  label,
  price,
  final,
  finalDiscount,
  itemNumber,
}: PriceDetailProps) => (
  <StyledContainer>
    <StyledRow
      $final={final}
      $finalDiscount={finalDiscount}
      role={finalDiscount ? "alert" : undefined}
    >
      <StyledLabel>
        {itemNumber !== undefined && <NumericBadge number={itemNumber} />}
        {label}
      </StyledLabel>

      <StyledPrices>
        <StyledPrice aria-label="מחיר נוכחי">
          {formatPrice(typeof price === "object" ? price.totalPrice : price)}
        </StyledPrice>

        {typeof price === "object" && price.discount > 0 && (
          <StyledPrice $original aria-label="מחיר לפני ההנחה">
            {formatPrice(price.originalPrice)}
          </StyledPrice>
        )}
      </StyledPrices>
    </StyledRow>
  </StyledContainer>
)

export default OnlinePrices
